module.exports = __webpack_public_path__ + "colorpalette_monochrome_blue_color.jpg?416396e119911c3f05a36d8d47cbe4dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/colorpalette_monochrome_blue_color.jpg
// module id = 48
// module chunks = 0